<template>
  <div class="h-full w-full">
    <div class="flex flex-column gap-2 justify-content-center align-items-center">
      <error-message
        v-if="errorType === 'server-unavailable'"
        title="ePeople Temporarily Unavailable!"
        description="We're experiencing technical difficulties but are working quickly to resolve them.
        You can still work as usual; you'll be able to manually log your hours when the system is restored.
        For immediate assistance, contact our support team."
        :imageSource="serverErrorImage"
      />

      <error-message
        v-else-if="errorType === 'no-permissions'"
        title="Access Denied"
        description="You do not have sufficient permissions to access this page. Please contact
        your company management to obtain the necessary permissions. If the issue
        persists, please reach out to support!"
        :imageSource="accessDeniedImage"
      />
      <error-message
        v-else-if="errorType === 'inactive-link'"
        title="Looks like this Link is no longer Active"
        description="Sometimes the links we send in emails or messages expire when the related information changes, gets updated, or is no longer available in the system.
        There’s nothing you need to do here. You can close this page and move on."
        :imageSource="inactiveLinkImage"
      />
      <error-message
        v-else
        :title="errorTitle"
        :description="errorDescription"
        :imageSource="errorType === 'not-found' ? accessDeniedImage : serverErrorImage"
      />
      <div class="flex gap-2">
        <a-button type="primary" @click="handleBack">Go Back</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorMessage from '@/components/error-message.vue'
import { Button } from 'ant-design-vue'
import Cookies from 'js-cookie'

export default {
  name: 'ErrorView',
  components: {
    'error-message': ErrorMessage,
    'a-button': Button
  },
  props: {
    errorType: {
      type: String,
      default: 'server-unavailable',
      validator: value => {
        return ['server-unavailable', 'no-permissions', 'not-found', 'custom', 'inactive-link'].includes(value)
      }
    },
    errorCode: {
      type: String,
      default: '503'
    },
    errorTitle: {
      type: String,
      default: 'Error'
    },
    errorDescription: {
      type: String,
      default: 'An error has occurred. Please try again later or contact support.'
    }
  },
  data() {
    return {
      serverErrorImage: require('@/assets/img/server-down.png'),
      accessDeniedImage: require('@/assets/img/access-denied.png'),
      inactiveLinkImage: require('@/assets/img/clean-up.png')
    }
  },
  methods: {
    handleBack() {
      if (Cookies.get('access')) {
        this.$router.back()
      } else {
        this.$router.push('/auth').catch(() => {})
      }
    },
    handleRoute() {
      if (Cookies.get('access')) {
        this.$router.push('/').catch(() => {})
      } else {
        this.$router.push('/auth').catch(() => {})
      }
    }
  }
}
</script>

<style scoped></style>
